import { render, staticRenderFns } from "./ModalCreateNote.vue?vue&type=template&id=3d557d00"
import script from "./ModalCreateNote.vue?vue&type=script&lang=js"
export * from "./ModalCreateNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports